import { render, staticRenderFns } from "./endotoxinas_cnsr2.vue?vue&type=template&id=45686c08&scoped=true"
import script from "./endotoxinas_cnsr2.vue?vue&type=script&lang=js"
export * from "./endotoxinas_cnsr2.vue?vue&type=script&lang=js"
import style0 from "./endotoxinas_cnsr2.vue?vue&type=style&index=0&id=45686c08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45686c08",
  null
  
)

export default component.exports